$(document).ready(function() {
  $(document).on('shopify:section:load', function(e){
    $('.cp_cd_js').removeClass('d-none');  
  })
  $(document).on('click', '.dcp_cd_btn', function(e) {
    var _this = $(this),
        html = _this.siblings('.dcp_cd_ip')[0]; 
    html.select();
    html.setSelectionRange(0, 99999)
    document.execCommand("copy");
    _this.text('Copied Shortcode');
  });
  
  var sps = '#shopify-section-',
      tcr = 'slideshow',
      jcr_ = '.js_carousel';
  
  var slickBlock = {
      select: function($parentSection,blockId){

        if ($('#cms_'+blockId).length > 0) {
          var slideIndex = $('#cms_'+blockId).closest(".wrap_slide").attr("data-slick-index");          
        } else {
          var slideIndex = $('#cms_b_'+blockId).closest('.js_image_slide').attr("data-slick-index"); 
        }
        
        $parentSection.find(jcr_).slick("slickGoTo", parseInt(slideIndex));
      },
      deselect: function($parentSection){
        //$parentSection.find(jcr_).slick("slickGoTo", 0);
      }
    };
  $(document).on('shopify:block:select', function(e){
    var id = e.detail.sectionId, blockId = e.detail.blockId,
        $parentSection = $(sps + id);    
    	 if ( $parentSection.hasClass(tcr) ) {
           slickBlock.select($parentSection,blockId);
         }
    
    if ($parentSection.hasClass('header_megamenu')) {
      if ($('#cms_'+blockId).length > 0 ) {
        //console.log('11');
        var li = $('.menu-item-has-children#item_'+$('#cms_'+blockId).attr("data-id"));
      } else {
        var li = $('.menu-item-has-children#item_'+blockId);
        //console.log('22');
      }
     
      $('.header_megamenu .menu-item').removeClass('menu_item_hover');
      li.addClass('menu_item_hover');

      $('.lazy_menu_mega').one('lazyincluded', function(e) {


      });
    }
    
  })
  $(document).on('shopify:block:deselect', function(e){
    var id = e.detail.sectionId, blockId = e.detail.blockId,
        $parentSection = $(sps + id);
      
    if ( $parentSection.hasClass(tcr) ) {
      slickBlock.deselect($parentSection);
    }

    if ($parentSection.hasClass('header_megamenu')) {
      $('.header_megamenu .menu-item').removeClass('menu_item_hover');
    }
      
  })
  
  $(document).on('shopify:section:load', function(e){    
    cmsheroShopify.init(); 
    cmsheroShopify.clone_main_menu();
    cmsheroShopify.popupSidebar();
    cmsheroShopify.searchProduct();
    cmsheroShopify.ajaxSwatch();
    cmsheroShopify.addItemCart();
    cmsheroShopify.stAddCart();    
    cmsheroShopify.initPopup();
    cmsheroShopify.checkSlide();
    cmsheroShopify.filtersAJX();   
    cmsheroShopify.sc_lazy();
    cmsheroShopify.pin_lookbook();
    cmsheroShopify.back_to_top();
    cmsheroShopify.quickView();
    cmsheroShopify.Sortby();
    cmsheroShopify.quantity();
    cmsheroShopify.Numberby();
    cmsheroShopify.changeTagFilter();
    cmsheroShopify.changeView();   
    cmsheroShopify.countdownProduct();
    cmsheroShopify.initVideo();    
    cmsheroShopify.tab_heading();
    cmsheroShopify.pagePopup(); 
    cmsheroShopify.initSlick();
    cmsheroShopify.SalesPopup();    
    $('body').addClass('loaded');
  })
  $(document).on('shopify:section:select', function(e){   
    var id = e.detail.sectionId,
    	$parentSection = $(sps + id);    
    var hnp = 'type_promotion_popup';
    if ( $parentSection.hasClass(hnp) ) {
    	cmsheroShopify.PromotionPopup(true);
    }
  })
  
})